@if (contentStore.page().group_sections && windowService.isInCompactMode()) {
<wyzeweb-mobile-accordion></wyzeweb-mobile-accordion>
} @else { @for (section of contentStore.page().sections; track $index + '-' + section.originalIndex) {
<!-- TODO: figure out why data doesn't exist on server even though its rendering as if it does -->
<wyzeweb-section ngSkipHydration [data]="section" [index]="$index"></wyzeweb-section>
} }
